import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getEntityLink } from 'helpers/getEntityLink';

export const Database = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(getEntityLink('database/clients'));
  }, []);
};
